import { useState } from "react";
import { useParams } from "react-router-dom";
import MediaHero from "../../components/media/MediaHero";
import PeopleList from "../../components/media/PeopleList";
import PaymentModal from "../../components/modals/PaymentModal";
import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import useScrollTop from "../../hooks/useScrollTop";
import endpoints from "../../api/endpoints";
import { useAuth } from "../auth/AuthContext";

/** Free titles use payment_method 3; anything else needs a purchase. */
export const needsPurchase = (media) =>
  media?.user_action?.purchased === false && media?.payment_method !== 3;

const MoviePage = () => {
  const { id } = useParams();
  const query = useApiQuery(endpoints.movie(id));
  const { isAuthenticated } = useAuth();
  const [paying, setPaying] = useState(false);
  useScrollTop([id]);

  return (
    <QueryBoundary {...query}>
      {(movie) => {
        const mustBuy = needsPurchase(movie);

        const handleClick = () => {
          if (!mustBuy) {
            window.open(`/PlayMovie/${movie.id}`, "_blank");
            return;
          }
          if (isAuthenticated) setPaying(true);
          else window.open("/Signup");
        };

        return (
          <div>
            <MediaHero media={movie} target="movie" shareType="movie">
              <button
                type="button"
                onClick={handleClick}
                className="mt-4 rounded border-b-4 border-brand bg-brand px-4 py-2 text-lg font-bold text-white transition hover:bg-brand-dark"
              >
                {mustBuy ? "پرداخت" : "تماشا"}
              </button>
              <PaymentModal
                open={paying}
                onClose={() => setPaying(false)}
                media={movie}
                type="movie"
              />
            </MediaHero>
            <PeopleList actors={movie.actors} />
          </div>
        );
      }}
    </QueryBoundary>
  );
};

export default MoviePage;
